import { Country } from '@philips-emr/tws-constants';
import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { Changeable, ChangeEventListener, Focusable, FocusEventListener, Keyboardable, KeyboardEventListener } from '@philips-emr/tws-core/lib/component/types';

class PhoneNumberAPI extends ComponentAPI implements Changeable<string>, Focusable, Keyboardable {

  /** @event */
  /** @event */
  @AwesomeEvent
  onChange = new ChangeEventListener<string>();

  /** @event */
  @AwesomeEvent
  onBlur = new FocusEventListener();

  /** @event */
  @AwesomeEvent
  onFocus = new FocusEventListener();

  /** @event */
  @AwesomeEvent
  onKeyDown = new KeyboardEventListener();

  /** @event */
  @AwesomeEvent
  onKeyPress = new KeyboardEventListener();

  /** @event */
  @AwesomeEvent
  onKeyUp = new KeyboardEventListener();

  getValue(): string {
    return this.state.value;
  }

  setValue(value: string): void {
    this.setState({ value });
  }

  getCountry(): Country {
    return this.state.country;
  }

  setCountry(country: Country): void {
    this.setState({ country });
  }

  isReadOnly(): boolean {
    return this.state.readOnly;
  }

  setReadOnly(readOnly: boolean): void {
    this.setState({ readOnly });
  }

  isEnabled(): boolean {
    return this.state.enabled;
  }

  setEnabled(enabled: boolean): void {
    this.setState({ enabled });
  }

}

export default PhoneNumberAPI;
